export default function (Vue) {
    Vue.prototype.clone = (item) => {
        return JSON.parse(JSON.stringify(item))
    }
}